import { Injectable } from "@angular/core";
import { HttpCemex } from "@cemex-core/angular-services-v8";
import { EndpointService } from "./../../services/helpers/endpoint.service";
import { Observable, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { ReasonCode } from "./../models/reason-code";

@Injectable()
export class ReasonCodeService {
  constructor(protected http: HttpCemex, protected endpointService: EndpointService) {}

  getReasonCodes(): Observable<ReasonCode[]> {
    const endpoint = this.endpointService.getUrl("v2", "pe", "partialpaymentreason");

    return this.http.get(endpoint).pipe(
      map((response: any) => response),
      catchError((error: any) => throwError("GET Request from Server error"))
    );
  }
}
